import { render, staticRenderFns } from "./gonggao.vue?vue&type=template&id=59e2582c&scoped=true&lang=true&"
import script from "./gonggao.vue?vue&type=script&lang=js&"
export * from "./gonggao.vue?vue&type=script&lang=js&"
import style0 from "./gonggao.vue?vue&type=style&index=0&id=59e2582c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e2582c",
  null
  
)

export default component.exports